<template>
  <div class="covoit-map-thumb">
    <div ref="mapEl" class="covoit-map-thumb__map"></div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
});

export default {
  name: "CovoitMapThumb",
  props: {
    lat: { type: Number, required: true },
    lng: { type: Number, required: true },
    zoom: { type: Number, default: 12}
  },
  data() {
    return { map: null };
  },
  created() {
    this._ro = null;
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.mapEl;
      if (!el) return;
      if (el.offsetHeight > 0) {
        this.initMap();
      } else {
        this._ro = new ResizeObserver(() => {
          if (el.offsetHeight > 0) {
            this._ro.disconnect();
            this._ro = null;
            if (!this.map) this.initMap();
            else this.map.invalidateSize();
          }
        });
        this._ro.observe(el);
      }
    });
  },
  beforeDestroy() {
    if (this._ro) { this._ro.disconnect(); this._ro = null; }
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
  methods: {
    initMap() {
      if (!this.$refs.mapEl) return;

      this.map = L.map(this.$refs.mapEl, {
        center: [this.lat, this.lng],
        zoom: this.zoom,
        zoomControl: false,
        attributionControl: false,
        dragging: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        boxZoom: false,
        keyboard: false,
        tap: false,
        touchZoom: false
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19
      }).addTo(this.map);

      L.marker([this.lat, this.lng]).addTo(this.map);

      this.map.invalidateSize();
    }
  }
};
</script>

<style scoped>
.covoit-map-thumb {
  width: 100%;
  height: 100%;
  flex: 1;
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.covoit-map-thumb__map {
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
